import React, { useEffect } from "react";
import styles from "./BubblePage.module.css";
import { JigglingCircles } from "./JigglingCircles";
import { useLayoutStore } from "~/store";
import { Heading } from "../Heading";
import { sendAnalyticsPageViewEvent } from "../../utils/adobeDataLayerUtils";

export const BubblePage = () => {
  const { isResetting, setContentClassName } = useLayoutStore();

  useEffect(() => {
    sendAnalyticsPageViewEvent("Passions-Bubbles3", 'Passions-Collection', 'bubbles');
  }, []);

  useEffect(() => {
    if (isResetting) {
      return;
    }

    setContentClassName(styles.parentContent);
  }, [isResetting]);

  return (
    <>
      <div className={styles.banner}>
        <Heading type="h1" text="Share Your Passions" />
        <p className={styles.subheader}>
          Tap once on the ones that you like and twice on the ones that you
          love.
        </p>
      </div>
      <div style={{ overflow: "hidden" }}>
        <JigglingCircles />
      </div>
    </>
  );
};
